import AddIcon from '@mui/icons-material/Add';
import { MenuItem, ListItemIcon, ListItemText, Alert, Paper, Toolbar, Typography, Stack, Snackbar, Backdrop, FormControl, InputLabel, Select, FormControlLabel, Switch, Grid, Box, Tooltip, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { apiResult, getUserSession, } from "../../Utils/Common";
import apis from "../../api";
import { RightDrawer } from "../../Component/MuiEx";
import { loadCourseCategories, settingDataLoader, } from "../../Component/DataLoader";
import ClassList from "./fragement/ClassList";
import CourseMembers from "./fragement/CourseMembers";
import ClassMembers from "./fragement/ClassMembers";
import ScheduleBar from './fragement/ScheduleBar';
import CourseRecords from './fragement/CourseRecords';
import { Add } from '@mui/icons-material';
import EditClass from './fragement/EditClass';
import { CoachLoader } from '../fragement/CoachSelector';
import { WeekDays } from '../../Utils/Dict';
import { CourseLoader } from '../fragement/CourseSelector';

const Classes = () => {
    const [loading,] = useState(false)
    const [rightDrawer, setRightDrawer] = useState()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)
    const [hintMsg, setHintMsg] = useState()
    const [curStatus, setCurStatus] = useState(1)
    const [refresh,setRefresh] = useState()
    const [currentDate, setCurrentDate] = useState({ year: new Date().getFullYear(), month: new Date().getMonth() + 1 })
    const [categories, setCategories] = useState()
    const [curCatetory, setCurCategory] = useState(0)
    const [curClass, setCurClass] = useState()
    const [classMemberCourses, setClassMemberCourses] = useState([])
    const [currentMemberCourse, setCurrentMemberCourse] = useState()
    const [classes,setClasses] = useState()
    const [classMembers,setClassMembers] = useState()
    const [courseMembers,setCourseMembers] = useState()
    const [classRooms,setClassrooms] = useState()
    const [coaches,setCoaches] = useState()
    const [courses,setCourses] = useState()
    const [error, setError] = useState()
    getUserSession(apis)
    const handleHintClose = () => {
        setHintMsg()
    }

    let initPage = false
    useEffect(() => {
        if (initPage) return
        initPage = true
        loadCourseCategories(apis, (data) => setCategories(data), setError)
        CourseLoader((data)=>setCourses(data),apis,true,setError)
        settingDataLoader('classroom', 1, apis, (rooms) => { setClassrooms(rooms) }, setError)
        CoachLoader((data) => setCoaches(data), apis)
    }, [])
    const loadCourseMembers = ()=>{        
        (curCatetory > 0||curClass) && apis.courseMembersGet(curCatetory>0?curCatetory:curClass.category_id).then(ret => {
            apiResult(ret, (r) => {                
                setCourseMembers(r)
            }, setError)
        })       
    }

    const loadClassMembers = (classid) => {
        apis.classmembers(classid, 1).then(ret => {
            apiResult(ret, data => {
                setClassMembers(data)
                let memberCourses = []
                for (let i = 0; i < data.length; i++) {
                    memberCourses.push(data[i].member_course)
                }
                setClassMemberCourses(memberCourses)
            }, setError)
        })
    }
    useEffect(()=>{
        if(curClass) {
            loadClassMembers(curClass.id)
            if(!curCatetory) {
                loadCourseMembers()
            }
        }else {
            setClassMembers()
            setClassMemberCourses()
        }
    },[curClass])
    const loadClassList = () => {
        apis.classes(curStatus, curCatetory).then(ret => {
            apiResult(ret, (r) => {                
                let cc = []
                
                for (let i = 0; i < r.length; i++) {
                    let cls = r[i]
                    let f = false
                    let dd;
                    for(let j =0;j<cc.length;j++) {
                        if(cc[j].week_date == cls.week_date) {
                            dd = cc[j]
                            f = true
                        }       
                    }
                    if(!f) {
                        dd = { week_date: cls.week_date, day: WeekDays[cls.week_date], classes: [], expand: false }
                        cc.push(dd)
                    }
                    dd.classes.push(cls)
                }                
                setClasses(cc)
            }, setError)
        })
    }
    useEffect(()=>{
        loadClassList()
        loadCourseMembers()
    },[curCatetory,curStatus])

    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }
    const handleClassClick = (item) => {
        setCurrentMemberCourse()
        setClassMemberCourses()
        setCurClass(item)
        setCurrentDate({year:currentDate.year,month:currentDate.month})
    }


    const handleAddMember = (memberCourse) => {
        curClass && window.confirm("Are you sure to add this member to the class " + curClass.name) &&
            apis.classmemberPost({ class_id: curClass.id, member_id: memberCourse.member_id, join_date: memberCourse.create_time?.substring(0, 10), member_course_id: memberCourse.id }).then(ret =>
                apiResult(ret, (data) => {
                    // setCurClass({ ...curClass })
                    loadClassList()
                    loadClassMembers(curClass.id)                    
                }, setError)
            )
    }
    const handleMemberCourseClick = (item) => {
        setCurrentMemberCourse(item)
    }
    const handleAfterEdit = (data, err, errs) => {
        let func = data.id == 0?apis.classPost:apis.classPut
        func(data).then(ret => {
            apiResult(ret, (id) => {
                setAutoCloseRightDraw(true)
                setRightDrawer(false)
                loadClassList()
            }, err, errs)
        })
    }
    const handleEditClass = (obj) => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<EditClass data={obj} onSubmit={(data, err, errs) => { handleAfterEdit(data, err, errs) }} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleMemberCourseUpdate = ()=>{        
        curClass && loadClassMembers(curClass.id)
        curCatetory && loadCourseMembers()
    }
    
    return (
        <>
            <Backdrop open={loading} />
            {/* <Paper sx={{ mb: 1,mt:1,}}>
                
            </Paper> */}
            {error && <Alert severity={"error"} sx={{ width: '100%', marginTop: "5px", mb: 2 }} onClose={() => setError()}>{error}</Alert>}
            <Grid container spacing={2}>
                <Grid item xs={3} >
                    <Paper><Box sx={{ display:"flex",pl:2,pr:2,pt:3,pb:3,borderBottom:"1px solid #8882" }}>
                        <FormControl sx={{ width: 250, mr: 1 }}>
                            <InputLabel id="select-course">{"Select Course"}</InputLabel>
                            <Select labelId="select-course"
                                defaultValue={0}
                                id="category_id" onChange={(e) => { setCurCategory(e.target.value); setCurClass();setCurrentDate({year:currentDate.year,month:currentDate.month}) }}
                                label={"Select Course"}>
                                {categories && [...categories, { id: 0, name: "All" }].map((p, idx) => {
                                    return <MenuItem key={idx} value={p.id}>{p.name}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        <Typography sx={{ flex: '1 1 5%' }} variant="h6" component="div" ></Typography>
                        <Tooltip title={curStatus == 1?"Show all classes":"Show active classes"}><FormControlLabel control={<Switch defaultChecked onChange={(e) => { setCurStatus(e.target.checked ? 1 : 0); }} />} label="" /></Tooltip>
                        <Tooltip title="Create new class"><IconButton size="small" onClick={()=>handleEditClass({id:0,category_id:curCatetory})} ><Add /></IconButton></Tooltip>
                    </Box>
                    <ClassList onEdit={(obj)=>handleEditClass(obj)} classList={classes} classRooms={classRooms} coaches={coaches} sx={{ maxHeight: '79vh', overflow: 'auto' }} category_id={curCatetory} onError={setError} onClick={handleClassClick} />
                    </Paper>
                </Grid>
                <Grid item xs={3} >
                    <Box sx={{ maxHeight: '80vh', overflow: 'auto' }}>
                        {curClass && <ClassMembers onRemove={(idx)=>{loadClassList();loadClassMembers(curClass.id)}} classMembers={classMembers} courses={courses} selected={currentMemberCourse} onClick={handleMemberCourseClick} sx={{ mb: 2 }} title={"Class Members"} onError={setError} />}
                        {(curCatetory>0 ||curClass) && <CourseMembers courseMembers={courseMembers} courses={courses} selected={currentMemberCourse} onClick={handleMemberCourseClick} onAddMember={handleAddMember} title={"Course Members"} filtMemberCourses={classMemberCourses} category_id={curCatetory > 0 ? curCatetory : curClass?.category_id} class_status={curStatus} onError={setError} />}
                    </Box>
                </Grid>
                <Grid item xs={6}>
                    <ScheduleBar week_date={curClass && curClass.week_date} onChange={(year, month, date) => { setCurrentDate({ year, month, date }) }} />
                    {(curCatetory > 0 || curClass) && <CourseRecords onMemberCourseUpdate={handleMemberCourseUpdate} sx={{ mt: 2, maxHeight: '85vh', overflow: 'auto' }} onHint={setHintMsg} category_id={curCatetory > 0 ? curCatetory : curClass?.category_id} onError={setError} classObj={curClass} memberCourse={currentMemberCourse} date={currentDate} />}
                </Grid>
            </Grid>

            {hintMsg && <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={hintMsg ? true : false} autoHideDuration={3000} onClose={handleHintClose}>
                <Alert onClose={handleHintClose} severity="success" sx={{ width: '100%' }}>{hintMsg}</Alert>
            </Snackbar>}
            <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
                {rightDrawer}
            </RightDrawer>
        </>

    )
}
export default Classes